import { render, staticRenderFns } from "./PolicyStatus.vue?vue&type=template&id=2b85aa94&scoped=true"
import script from "./PolicyStatus.vue?vue&type=script&lang=js"
export * from "./PolicyStatus.vue?vue&type=script&lang=js"
import style0 from "./PolicyStatus.vue?vue&type=style&index=0&id=2b85aa94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b85aa94",
  null
  
)

export default component.exports